import find from 'lodash/find'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'
import { findNameByID } from '../../../function'

export const generateCompensateReportList = (compensateReport, users, projects) => {
  const newReport = []
  compensateReport.map(report => {
    const compensate = {}
    const user = find(users, { _id: report.user_id })
    const project = find(projects, { _id: report.project_id })
    const approver = find(users, { _id: report.approver_id })
    compensate._id = report._id
    compensate.status = report.status
    compensate.start_date = moment(report.start_date).format('YYYYMMDD')
    compensate.end_date = moment(report.end_date).format('YYYYMMDD')
    compensate.days = report.days
    compensate.working_time = report.compensate_time
    compensate.emp_code = user ? user.emp_code : '-'
    compensate.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
    compensate.project = project ? `${project.project_code} - ${project.name}` : '-'
    compensate.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
    compensate.remark_request_user = report.remark_request_user
    compensate.remark_approver = report.remark_approver
    newReport.push(compensate)
    return report
  })
  return newReport
}

export const generateSubcontractReportList = (subcontractReport, users, projects) => {
  const newSubcontract = []
  subcontractReport.map(report => {
    const subcontract = {}
    const user = find(users, { _id: report.user_id })
    const project = find(projects, { _id: report.project_id })
    subcontract.days = report.days
    subcontract.emp_code = user ? user.emp_code : '-'
    subcontract.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
    subcontract.project = project ? `${project.project_code} - ${project.name}` : '-'
    subcontract.period = `${moment().month(report.month - 1).format('MMMM')} ${report.year}`
    subcontract.cost = report.total_cost
    subcontract.rate = report.cost_per_day
    subcontract.status = report.status
    newSubcontract.push(subcontract)
    return report
  })
  return newSubcontract
}

/* eslint no-underscore-dangle: 0 */
export const generateLeaveGenerationList = (leaveGenerationUsers, companys, lobs) => {
  const temp = []
  if (leaveGenerationUsers) {
    leaveGenerationUsers.map(employee => {
      if (!employee.is_system_admin) {
        const emp = {}
        emp.emp_code = get(employee, 'emp_code', '')
        emp.name = `${get(employee, 'first_name', '')} ${get(employee, 'last_name', '')}`
        emp.first_name = get(employee, 'first_name', '')
        emp.last_name = get(employee, 'last_name', '')
        emp.nick_name = get(employee, 'nick_name', '')
        emp.company = findNameByID(get(employee, 'company_id', ''), companys)
        emp.lob = findNameByID(get(employee, 'lob_id', ''), lobs)
        emp._id = get(employee, '_id', '')
        temp.push(emp)
      }
      return employee
    })
  }
  return temp
}



// WEBPACK FOOTER //
// ./src/components/report/helpers/report.js